// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function planType_decode($$enum) {
  if ($$enum === "PRO" || $$enum === "FREE" || $$enum === "COMPLIMENTARY" || $$enum === "PRO_ONLY") {
    return $$enum;
  }
  
}

function planType_fromString(str) {
  return planType_decode(str);
}

var Utils = {
  planType_decode: planType_decode,
  planType_fromString: planType_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingSettingsPageRelay_accountV5",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingSettingsPagePaymentCard_accountV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingSettingsPageSubscription_accountV5"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "sub",
        "args": null,
        "concreteType": "AccountSubscriptionV5",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": "SubscriptionPlanV5",
              "kind": "LinkedField",
              "name": "plan",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": "planType",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  "action": "THROW"
                }
              ],
              "storageKey": null
            },
            "action": "THROW"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "AccountV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
